/* global TokenizeJs */
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import { ApplePayConstants } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import ApplePayStore from './ApplePayStore';

const { dispatchServerAction } = AppDispatcher;

class PoyntPaymentRequestActions {
  init() {
    const {
      poynt_config: { sdk_url }
    } = OlsConfigStore.getState();

    if (ApplePayStore.getState().poyntWasLoaded) {
      return;
    }

    const script = window.document.createElement('script');
    script.src = sdk_url;
    script.type = 'text/javascript';
    script.onload = () => {
      dispatchServerAction({
        type: ApplePayConstants.POYNT_WAS_LOADED
      });
    };
    window.document.body.appendChild(script);
  }

  buildLineItems(order) {
    const lineItems = [];

    if (order && order.summary_line_items) {
      for (const item of order.summary_line_items) {
        lineItems.push({
          label: item.label,
          amount: item.amount,
          type: 'final'
        });
      }
    }

    return lineItems;
  }

  buildShippingMethods(order) {
    const methods = [];

    if (order) {
      for (const rate of order.shipping_rates) {
        methods.push({
          id: rate.id.toString(),
          label: rate.method,
          detail: '',
          amount: rate.cost
        });
      }
    }

    return methods;
  }

  updatePaymentRequest(order, error = false) {
    const { store_name } = OlsConfigStore.getState();

    const paymentRequest = {
      total: {
        amount: order ? order.balance_due : '0.00',
        label: store_name,
        type: 'final'
      },
      shippingMethods: this.buildShippingMethods(order),
      lineItems: this.buildLineItems(order)
    };

    if (error) paymentRequest.error = error;

    return paymentRequest;
  }

  buildPaymentRequest(order) {
    const {
      country_iso,
      currency,
      store_name,
      show_coupon,
      stripe_config: { require_phone_number }
    } = OlsConfigStore.getState();
    const lineItems = this.buildLineItems(order);
    const shippingMethods = this.buildShippingMethods(order);

    return {
      merchantName: store_name,
      country: country_iso,
      currency: currency.code.toUpperCase(),
      requireEmail: true,
      requireShippingAddress: true,
      requirePhone: require_phone_number,
      lineItems,
      supportCouponCode: show_coupon,
      shippingMethods,
      total: {
        amount: order ? order.balance_due : '0',
        label: store_name,
        type: 'final'
      }
    };
  }

  checkAvailability() {
    const { poyntWasLoaded } = ApplePayStore.getState();
    const { business_id, application_id, with_google_pay } = OlsConfigStore.getState().poynt_config;

    dispatchServerAction({
      type: ApplePayConstants.AVAILABILITY_WAS_CHECKED
    });

    if (poyntWasLoaded && typeof TokenizeJs !== 'undefined') {
      const paymentRequest = this.buildPaymentRequest();
      this.poyntCollect = new TokenizeJs(business_id, application_id, paymentRequest);
      this.poyntCollect.supportWalletPayments().then(({ applePay, googlePay }) => {
        if (applePay) {
          dispatchServerAction({
            type: ApplePayConstants.APPLE_PAY_IS_AVAILABLE
          });
        } else if (with_google_pay && googlePay) {
          dispatchServerAction({
            type: ApplePayConstants.APPLE_PAY_IS_AVAILABLE
          });
        }
      });
    }
  }

  getInstance() {
    return this.poyntCollect;
  }
}

export default new PoyntPaymentRequestActions();
